import { render, staticRenderFns } from "./live-list.vue?vue&type=template&id=9a62bb2e&scoped=true&"
import script from "./live-list.vue?vue&type=script&lang=js&"
export * from "./live-list.vue?vue&type=script&lang=js&"
import style0 from "./live-list.vue?vue&type=style&index=0&id=9a62bb2e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a62bb2e",
  null
  
)

export default component.exports